import React, { Fragment, useContext, useEffect } from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { ContainerNew, SubMenu, RightMenu } from "../Layout";

import { RightMenuLayer } from "./RightMenuLayer";

export default (props) => {
    const {userinfo, cfg} = useContext(AppContext);

    useEffect(() => {
    })

    return (
        <Fragment>

            <ContainerNew Title={ '회사소개' }
                dark={'dark'} 
                leftMenu={SubMenu} goToUrl={'/mp'} 
                rightMenu={RightMenu}
            >

                <div className="contents">
                    <div className="sub-contents">

                        <div>내용없음</div>

                    </div>
                </div>
            </ContainerNew>

            <RightMenuLayer />

        </Fragment>
    );
};